import { memo, PropsWithChildren } from "react";
import Box from "@mui/material/Box";
import { Outlet } from 'infrastructure/router';
import { Stats, Stepper } from "../widgets";
import { OnboardingStepLayout } from "../layouts";
import type { WithStep } from "../hooks";

const Onboarding = ({ children, ...widgetProps }: PropsWithChildren<WithStep>) => (
    <OnboardingStepLayout
        {...widgetProps}
    >
        <Box
            sx={{
                justifySelf: 'flex-end',
                display: 'flex',
                alignItems: 'flex-start',
                paddingTop: "10px",
            }}
        >
            <Stepper
                {...widgetProps}
                slots={{
                    stats: (
                        <Stats
                            {...widgetProps}
                        />
                    )
                }}
            >
                {children}
            </Stepper>
        </Box>
        <Box
            sx={{
                justifySelf: 'flex-end',
                display: 'flex',
                alignItems: 'flex-start',
                paddingTop: "34px",
                maxWidth: '480px',
            }}>
            <Outlet />
        </Box>
    </OnboardingStepLayout>
);

export default memo(Onboarding);
